export const breakpoint = {
  phone: { min: 0, max: 639 },
  tablet: { min: 640, max: 1023 },
  smallDesktop: { min: 1024, max: 1087 },
  desktop: { min: 1088, max: 10328 },
};

export const column = {
  phone: "4px",
  tablet: "6px",
  smallDesktop: "12px",
  desktop: "12px",
};

export const margin = {
  phone: "16px",
  tablet: "24px",
  smallDesktop: "24px",
  desktop: "24px",
};

export const gutter = {
  phone: "16px",
  tablet: "16px",
  smallDesktop: "16px",
  desktop: "16px",
};

export const mediaQuery = {
  phone: `(min-width: ${breakpoint.phone.min}px) and (max-width: ${breakpoint.phone.max}px) `,
  tablet: `(min-width: ${breakpoint.tablet.min}px) and (max-width: ${breakpoint.tablet.max}px) `,
  smallDesktop: `(min-width: ${breakpoint.smallDesktop.min}px) and (max-width: ${breakpoint.smallDesktop.max}px) `,
  desktop: `(min-width: ${breakpoint.desktop.min}px)) `,
};

export type BreakpointKeys = keyof typeof breakpoint;
export type Breakpoint = typeof breakpoint;

export type ColumnKeys = keyof typeof column;
export type Column = typeof column;

export type MarginKeys = keyof typeof margin;
export type Margin = typeof margin;

export type GutterKeys = keyof typeof gutter;
export type Gutter = typeof gutter;

export type MediaQueryKeys = keyof typeof mediaQuery;
export type MediaQuery = typeof mediaQuery;
